class ClinicInfoMapper {
  toDomain(persistenceClinicData) {
    return {
      canUnblockCreditCard:
        persistenceClinicData?.clinicaConfig?.flagPermiteConsultaParticular &&
        persistenceClinicData?.clinicaConfig?.flagPermitePagamentoCredito,
      flagClinicHasPatientPlan:
        persistenceClinicData?.clinicaConfig?.flagClinicaPossuiPlanoPaciente,
      activationKey:
        persistenceClinicData?.clinicaConfig?.identificadorAtivacao,
    }
  }
}

export default new ClinicInfoMapper()
